// config/AppVersion.js
export const appVersion = 'v1.1.29'; // Versão do aplicativo